import React from "react";

import { FooterLinksStreamBlock as Value } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { Clickable } from "../Clickables";
import { RichText } from "../RichText";

import styles from "./FooterLinks.module.scss";

interface Props {
    value: Value;
}

export const footerLinksComponents: StreamFieldBlockMap<Value> = {
    text: ({ value }) => <RichText value={value} className={styles.richText} />,
    link: ({ value }) => (
        <Clickable simpleLink={value} className={styles.cta} />
    ),
};

export const FooterLinks = ({ value }: Props) => (
    <div className={styles.root}>
        <StreamField
            tagName={React.Fragment}
            components={footerLinksComponents}
            value={value}
        />
    </div>
);
